import { doesCountryUse12HoursFormat } from './location';

export const TELEMETRY_ACCURACY_DEFAULT_VALUE = 2;
export const TELEMETRY_MULTIPLICATOR_DEFAULT_VALUE = 1.0;
export const TELEMETRY_TIME_FORMAT = 'x';

export const getTelemetryGraphDateTimeFormat = (options = {}) => {
  const {
    useSeconds = true,
    showDate = false,
    dateInNewLine = false,
  } = options;

  const is12HoursFormat = doesCountryUse12HoursFormat();
  let format = 'HH:mm:ss';

  if (useSeconds) {
    format = is12HoursFormat ? 'hh:mm:ss A' : 'HH:mm:ss';
  } else {
    format = is12HoursFormat ? 'hh:mm A' : 'HH:mm';
  }

  if (showDate) {
    format = dateInNewLine ? `MM/DD[\r\n] ${format}` : `MM/DD ${format}`;
  }

  return format;
};
